import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Michigan = () => {
  return (
    <StatePropertyTaxPage
      stateName="Michigan"
      processDescription="Property owners receive notice in February and can file an appeal with the local Board of Review. Appeals must be presented in person or via authorized representative or written submission before or during the meeting. It's worth noting that in Michigan, the taxable value of a property is capped, meaning it can only increase by a certain amount (the rate of inflation or 5%, whichever is lower) each year, until a transfer of ownership occurs, at which point the taxable value is 'uncapped' and can increase to the assessed value level."
      noticeOfValueMailed="February"
      noticeOfValueMailedDateExplanation="Assessment notices mailed in February; residents may appeal to the March Board of Review."
      valuationAsOfDate="December 31 of the prior year"
      valuationAsOfDateExplanation="Under MCL 211.2(2), taxable value is based on the property's status and condition as of December 31 of the prior year (Tax Day). This unique timing captures the property's condition at year-end for the following tax year."
      deadlineExplanation="Per Michigan statute, appeals must be submitted by the local Board of Review's meeting, typically held on the 2nd Monday in March. This deadline is strictly enforced across all Michigan municipalities."
    />
  );
};

export default Michigan;